import { useContext } from 'react';
//
import { LoadingContext } from 'contexts/loading-context';

// ----------------------------------------------------------------------

export default function useLoadingContext() {
    const context = useContext(LoadingContext);

    if (!context) throw new Error('useAuthContext context must be use inside AuthProvider');

    return context;
};
